import type { HighRangeOption, LowRangeOption } from 'flow/service/actions';
import type { MatrixModel } from 'flow/store/engine/types';


export enum AxisTypeOption {
  range = 'range', exact = 'exact',
}
export enum AxisOrderOption {
  asc = 'asc', desc = 'desc',
}

export interface AxisOptions {
  axisType: AxisTypeOption;
  axisOrder: AxisOrderOption;
  highRange: HighRangeOption;
  lowRange: LowRangeOption;
}

export interface UpdateAxisSettingsProps {
  initialOptions: AxisOptions;
  selectedOptions: AxisOptions;
  axisHeader: MatrixModel['axis']['x' | 'y']['axisHeader'];
}
